import { useEffect, useState } from "react";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "../../assets/api/endpoint";
import { saveUnseenData } from "../../redux/UserDataSlice";
import { apiHandler } from "../../assets/api";

const NotificationSocketListener = () => {
  const { userAuthId, accessToken } = useSelector((state) => state.loginInfo);
  const [notificationData, setNotificationData] = useState([]);
  const [socketNotifications, setSocketNotifications] = useState([]);
  const dispatch = useDispatch();

  
  useEffect(() => {
    const fetchInitialNotifications = async () => {
      try {
        const result = await apiHandler({
          url: endpoint.NOTIFICATION_PENDING,
          method: "GET",
          authToken: accessToken?.accessToken,
        });
        if (result?.data?.notifications) {
          const fetched = result.data.notifications;
          const unseenCount = fetched.filter(item => item.seen === false).length;
          setNotificationData(fetched);
          dispatch(saveUnseenData( unseenCount ))

        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    };

    if (accessToken?.accessToken) {
      fetchInitialNotifications();
    }
  }, [accessToken, dispatch,socketNotifications]);

  useEffect(() => {
    const socket = new SockJS(`${endpoint.BASE_URL_STAGING}public/ws`);
    const stompClient = Stomp.over(socket);

    stompClient.connect({}, () => {
      if (userAuthId) {
        stompClient.subscribe(`/notification/${userAuthId}`, (message) => {
          const payload = JSON.parse(message.body);
          setSocketNotifications((prev) => [...prev, payload]);
        });
      }
    });

    return () => {
      if (stompClient && stompClient.connected) {
        stompClient.disconnect();
      }
    };
  }, [userAuthId]);

  return null;
};

export default NotificationSocketListener;
